import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const quoteRevertToOpenAtom = createMutationAtomFactory(
  'brokerage.quoteRevertToOpen',
  (params: { id: string }) => ({
    tradeQuoteRevertToOpen: {
      __args: {
        id: params.id,
      },
      id: true,
      status: true,
      timestamps: {
        updatedAt: true,
      },
    },
  }),
);
